



























































import Vue from 'vue';
import Auth from '@aws-amplify/auth';

import amplifyMixin from '@/mixins/amplify';
import { SET_USER } from '@/assets/src/store/mutation_types';

import ROUTE_NAMES from '@/assets/src/routes';

export default Vue.extend({
  name: 'AuthSignIn',

  mixins: [amplifyMixin],

  methods: {
    completeSignIn() {
      this.$store.commit(SET_USER, this.user);
      this.$router.push({ name: ROUTE_NAMES.FIND_USER });
    },

    signIn() {
      Auth.signIn(this.username, this.password)
        .then((user) => {
          this.user = user;
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.newPasswordRequired = true;
            this.message = 'One time password detected. You must change your password.';
            return;
          }

          this.completeSignIn();
        })
        .catch(this.setError);
    },

    changePassword() {
      if (!this.user) {
        this.newPasswordRequired = false;
        return;
      }

      this.user.completeNewPasswordChallenge(this.newPassword, this.user.challengeParam.requiredAttributes, {
        onSuccess: this.completeSignIn,
        onFailure: this.setError,
      });
    },

    async submitForm() {
      this.error = '';

      if (this.newPasswordRequired) {
        this.changePassword();
      } else {
        this.signIn();
      }
    },
  },

  data() {
    return {
      user: null as any | null,
      message: '',
      username: '',
      password: '',
      newPassword: '',
      newPasswordRequired: false,
    };
  },

  routeNames: ROUTE_NAMES,
});
